import { TextArea } from '@pandiafi/design-system'
import { Field, FieldProps } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ContractType } from '../../../../../common/types'
import { resolveContractTerminationTerminology } from '../../utils/resolveContractTerminationTerminology'

import FormFieldWrapper from 'components/FormField'
import { FormValues } from 'views/TerminateContract/TerminateForm/initialValues'

interface AdditionalDetailsFieldProps {
  contractType: ContractType
}

export const AdditionalDetailsField: React.FC<AdditionalDetailsFieldProps> = ({
  contractType,
}) => {
  const [t] = useTranslation(['terminateContract'])
  const terminology = resolveContractTerminationTerminology(contractType)

  return (
    <Field name="additionalDetails">
      {({ field, meta, form }: FieldProps<FormValues['additionalDetails']>) => (
        <FormFieldWrapper
          name={field.name}
          label={t('terminateContract:labels.additionalDetails')}
          className="min-tablet:flex-1"
          meta={meta}
          labelBold
        >
          <TextArea
            onChange={(e) => form.setFieldValue(field.name, e.target.value)}
            placeholder={t(terminology.additionalDetailsPlaceholder)}
            value={meta.value}
          />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
